import type {UsersSearch} from "./list-users.schema";
import type {ListUsersParams} from "@project/sdk/admin";

export const listUsersMapper = {
  toSdk: (search: Partial<UsersSearch>): ListUsersParams => ({
    page: search.page ?? 1,
    perPage: search.perPage ?? 20,
    q: search.q,
    sortBy: search.sortBy,
    sortDir: search.sortDir,
    roles: search.roles,
    dateRangeStart: search.dateRangeStart,
    dateRangeEnd: search.dateRangeEnd,
    departments: search.departments,
    seniorityRangeMin: search.seniorityRangeMin,
    seniorityRangeMax: search.seniorityRangeMax,
  }),
};
